import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { logout } from '../services/adminApi';
import BannersList from './components/BannersList';
import JobsList from './components/JobsList';

import ContactSubmissionsList from './components/ContactSubmissionsList';
import VideoBannersList from './components/VideoBannersList';
import UsersList from './components/UsersList';
import JobsModeration from './components/JobsModeration';
import './Dashboard.css';

const Dashboard = () => {
  const [activeTab, setActiveTab] = useState('moderation');
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  return (
    <div className="admin-dashboard">
      <div className="admin-header">
        <h1>Панель администратора</h1>
        <button onClick={handleLogout} className="logout-btn">Выйти</button>
      </div>

      <div className="admin-nav">
        <button
          className={activeTab === 'banners' ? 'active' : ''}
          onClick={() => setActiveTab('banners')}
        >
          Баннеры
        </button>
        <button
          className={activeTab === 'moderation' ? 'active' : ''}
          onClick={() => setActiveTab('moderation')}
        >
          Модерация
        </button>
        <button
          className={activeTab === 'jobs' ? 'active' : ''}
          onClick={() => setActiveTab('jobs')}
        >
          Все вакансии
        </button>

        <button
          className={activeTab === 'messages' ? 'active' : ''}
          onClick={() => setActiveTab('messages')}
        >
          Сообщения
        </button>
        <button
          className={activeTab === 'video-banners' ? 'active' : ''}
          onClick={() => setActiveTab('video-banners')}
        >
          Видео Баннеры
        </button>
        <button
          className={activeTab === 'users' ? 'active' : ''}
          onClick={() => setActiveTab('users')}
        >
          Пользователи
        </button>
      </div>

      <div className="admin-content">
        {activeTab === 'moderation' && <JobsModeration />}
        {activeTab === 'banners' && <BannersList />}
        {activeTab === 'jobs' && <JobsList />}

        {activeTab === 'messages' && <ContactSubmissionsList />}
        {activeTab === 'video-banners' && <VideoBannersList />}
        {activeTab === 'users' && <UsersList />}
      </div>
    </div>
  );
};

export default Dashboard;

